module.exports = __webpack_public_path__ + "img/123-before.697595c9.png";